module.exports = __webpack_public_path__ + "static/img/installedDMSbgEng.720912d.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/installedDMSbgEng.png
// module id = FQAX
// module chunks = 1